import React, { useContext, useEffect, useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import SaveBackdrop from '../../../components/saveBackdrop';
import { AppContext } from '../../../contexts/app-context';
import GlobalStyles from '../../../global-styles';
import { getEnlistmentParentAccountSearch } from '../../../utils/helper';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, TextField, Typography
} from '../../../utils/material-ui-core';

interface ConfirmProps {
  locationItemKey: string;
  open: boolean;
  callActionButton: (confirmOutput: ConfirmOutput) => void;
}

interface ParentAccount {
  accountNumber: string,
  name: string,
  displayName: string,
  checked: boolean
}

const ParentAccountSearch = ({ locationItemKey, open, callActionButton }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const { showAlert } = useContext(AppContext);

  const [searchText, setSearchText] = useState<string>("");
  const [searchList, setSearchList] = useState<ParentAccount[]>([]);
  const [selectedParentAccount, setSelectedParentAccount] = useState<ParentAccount | null>(null);
  const [saveInProgress, setSaveInProgress] = useState<boolean>(false);

  const handelCheckBoxChange = (selectedValue: ParentAccount) => {

    const updateData = searchList.map(rowItem => {
      rowItem.checked = false;
      if (rowItem.accountNumber === selectedValue.accountNumber) {
        rowItem.checked = true;
        setSelectedParentAccount(rowItem);
      }
      return rowItem;
    });

    setSearchList(updateData);
  }


  const search = async () => {
    setSearchList([]);

    setSaveInProgress(true);
    const apiResponse = await getEnlistmentParentAccountSearch(locationItemKey, searchText);

    if (apiResponse.success) {
      const parentAccounts: ParentAccount[] = [];

      apiResponse.data.parentAccounts.map(account => (
        parentAccounts.push({ accountNumber: account.accountNumber, name: account.name, displayName: account.name + " (" + account.accountNumber + ")", checked: false }))
      );

      setSearchList(parentAccounts);
      setSelectedParentAccount(null);

    } else {
      showAlert({ message: apiResponse.errorMessage, severity: "error" });
    }
    setSaveInProgress(false);
  };


  const selectParentAccount = () => {
    callActionButton({ status: "select", data: selectedParentAccount })
  }

  const cancel = () => {
    callActionButton({ status: "cancel", data: null })
  }

  useEffect(() => {
    if (open) {
      setSearchText("");
      setSearchList([]);
      setSelectedParentAccount(null);
    }
    else {
      setSearchText("");
      setSearchList([]);
      setSelectedParentAccount(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>

      <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"sm"} fullWidth={true}>
        <DialogTitle id="input-dialog-title" className={globalStyles.dialogTitleContainer}>
          <Typography variant="subtitle1" component="div">
            Parent Account Search
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <SaveBackdrop open={saveInProgress} />
          <DialogContentText className={pageStyles.contentText} component="div">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={8} md={9}  >
                <TextField
                  id="searchText"
                  name="searchText"
                  label="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value as string);
                    setSearchList([]);
                  }}
                />

                {searchText.length <= 2 ?
                  <FormHelperText className={globalStyles.error}>A minimum of 3 characters are required to search the parent account.</FormHelperText>
                  : null}
              </Grid>
              <Grid item xs={12} sm={4} md={3} >
                <Box display="flex" alignContent="center" justifyContent="center">
                  <Button disabled={searchText.length >= 3 ? false : true} color="primary" variant="contained" className={globalStyles.buttonDefault} onClick={search}>Search</Button>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box className={pageStyles.dialogContentContainer}>
                  <RadioGroup>
                    {

                      searchList.map((item, index) => (
                        <FormControlLabel
                          key={index}
                          value={item.accountNumber}
                          checked={item.checked}
                          control={<Radio />}
                          label={item.displayName}
                          onChange={(event: any) => {
                            handelCheckBoxChange(item);
                          }} />
                      ))

                    }
                  </RadioGroup>
                </Box>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {selectedParentAccount !== null ?
            <Button onClick={selectParentAccount} color="secondary" variant="contained" className={globalStyles.buttonDefault}>
              Select
            </Button>
            : null
          }

          <Button onClick={cancel} autoFocus className={globalStyles.buttonDefault}>
            <u>Close</u>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      whiteSpace: "pre-wrap",
      "& .MuiChip-root": {
        maxWidth: "300px",
        borderRadius: theme.spacing(1),
        "& .MuiChip-label": {
          paddingTop: "4px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    },
    dialogContentContainer: {
      minHeight: "400px",
      height: "calc(100vh - 320px)",
      overflow: "auto",
      width: "100%",
    }
  })
);

export default ParentAccountSearch;
